import { ReactNode } from 'react';
import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/react';
import { NavMenuItem } from '@employ-engage/data';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export interface IconMenuProps {
  icon: ReactNode;
  menuItems: NavMenuItem[];
  headerText?: string;
}

export function IconMenu({ icon, menuItems, headerText }: IconMenuProps) {
  const { t } = useTranslation(['common']);
  return (
    <Menu as="div" className="relative inline-block text-left">
      <div>
        <MenuButton className="flex items-center rounded-full bg-gray-100 text-gray-400 hover:text-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 focus:ring-offset-gray-100">
          <span className="sr-only">{t('Open menu')}</span>
          {icon}
        </MenuButton>
      </div>

      <MenuItems
        transition
        className="absolute right-0 z-10 mt-2 w-56 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black/5 transition focus:outline-none data-[closed]:scale-95 data-[closed]:transform data-[closed]:opacity-0 data-[enter]:duration-100 data-[leave]:duration-75 data-[enter]:ease-out data-[leave]:ease-in"
      >
        <div className="py-1">
          {headerText && (
            <div className="pl-4 pt-4 font-bold">{headerText}</div>
          )}
          {menuItems.map((item) => {
            if (item.to) {
              return (
                <MenuItem key={item.title}>
                  <Link
                    to={item.to}
                    className="block px-4 py-2 text-sm text-gray-700 data-[focus]:bg-gray-100 data-[focus]:text-gray-900 data-[focus]:outline-none"
                  >
                    {item.title}
                  </Link>
                </MenuItem>
              );
            } else if (item.onClick) {
              return (
                <MenuItem key={item.title}>
                  <button
                    onClick={item.onClick}
                    className="text-left w-full block px-4 py-2 text-sm text-gray-700 data-[focus]:bg-gray-100 data-[focus]:text-gray-900 data-[focus]:outline-none"
                  >
                    {item.title}
                  </button>
                </MenuItem>
              );
            }
            return null;
          })}
        </div>
      </MenuItems>
    </Menu>
  );
}

export default IconMenu;
